import UserPlanSubscriptionAPI from '~/api/userPlanSubscription';
import PaymentInformationAPI from '~/api/paymentInformationApi';
import CenteredModal from '~/components/CenteredModal'
import {Fragment, useEffect, useState} from "react";
import { format } from "date-fns";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAddressCard, faPen} from "@fortawesome/free-solid-svg-icons";
import Table from '~/components/Table';

function formatLabel(key) {
    return key
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2") // xử lý các cụm viết hoa
        .replace(/^./, (str) => str.toUpperCase());
}

function PaymentAndPlanTab({title}){
    const [userPlanSubscription, setUserPlanSubscription] = useState([]);
    const [paymentInformation, setPaymentInformation] = useState({});
    const [showModalPaymentInfo, setShowModalPaymentInfo] = useState(false);
    const userId = '3bb73dc3-9a90-4bf7-949e-78ca159679c2';
    const handlePaymentInformation = (id) => {
        PaymentInformationAPI.getByUserPlanSubscriptionId(id)
        .then((res) => {
            setPaymentInformation(res.data);
        })
        .catch((err) => {
            ;
        });
        setShowModalPaymentInfo(true);
    }
    const tableConfig = {
        columns: [
            {
                name: 'SERVICE PLAN',
                width: '150px',
                key: 'ServicePlan'
            },
            {
                name: 'START DATE',
                width: '200px',
                className: 'fw-bold',
                template: (row) => {
                    return (
                        format(new Date(row.StartDate), "dd/MM/yyyy hh:mm:ss a")
                    )
                }
            },
            {
                name: 'END DATE',
                width: '200px',
                className: 'fw-bold',
                template: (row) => {
                    return (
                        format(new Date(row.EndDate), "dd/MM/yyyy hh:mm:ss a")
                    )
                }
            },
            {
                name: 'PAYMENT INFORMATION',
                className: "text-center",
                width: '170px',
                template: (row) => {
                    return (
                        <FontAwesomeIcon onClick={() => handlePaymentInformation(row.UserPlanSubscriptionId)} style={{color: "green"}} className="fw-semibold cursor-pointer" icon={faAddressCard}/>
                    )
                }
            },
            {
                name: 'PAYMENT STATUS',
                width: '150px',
                key: 'PaymentStatus'
            },
            {
                name: 'SUBSCRIPTION MONTHS',
                width: '200px',
                key: 'SubscriptionMonths'
            },
            {
                name: 'PRICE PER MONTH',
                width: '150px',
                key: 'PricePerMonth'
            },
            {
                name: 'DISCOUNT',
                width: '100px',
                key: 'Discount'
            },
            {
                name: 'AMOUNT PAID',
                width: '120px',
                key: 'AmountPaid'
            }
        ],
        data : []
    }
    useEffect(function(){
        UserPlanSubscriptionAPI.getByUserId(userId)
            .then((res) => {
                setUserPlanSubscription(res.data);
            })
            .catch((err) => {
                ;
            });
    }, []);

    return (
        <Fragment>
            <div className="mb-6">
                <h4 className="mb-4 text-center">{title}</h4>
                <Table tableConfig={{...tableConfig, data : userPlanSubscription}}/>
            </div>
            <CenteredModal show={showModalPaymentInfo} modalType="modal-md" title="Payment information" onClose={ () =>  setShowModalPaymentInfo(false)}>
                <div className="mb-3">
                    <div className="row mb-3">
                        {
                            Object.entries(paymentInformation).map(([key, value]) => (
                                <div className="col-12 col-sm-6 mb-3" key={key}>
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control text-primary ps-2 shadow-none"
                                            id={key}
                                            value={value}
                                            placeholder={key}
                                            readOnly
                                        />
                                        <label htmlFor={key} className="ps-2 text-body-tertiary form-icon-label text-primary">
                                            {formatLabel(key)}
                                        </label>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </CenteredModal>
        </Fragment>
    )
}
export default PaymentAndPlanTab;